import { render, staticRenderFns } from "./StudyInformationTableForm.vue?vue&type=template&id=0a32257a"
import script from "./StudyInformationTableForm.vue?vue&type=script&lang=js"
export * from "./StudyInformationTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports